import { IChatGuest } from './chat-guest';

export const TYPE_ADD = 'add';

export interface IMemberUpdateDto {
  userId: string;
  firstName: string;
  lastName: string;
  type: string;
  membersToNotify: Array<string>;
  chatId: string;
}

export class MemberUpdateDto {
  static from(memberToAdd: IChatGuest, membersToNotify: Array<string>, chatId: string, type: typeof TYPE_ADD): IMemberUpdateDto {
    return {
      userId: memberToAdd.id,
      firstName: memberToAdd.firstName,
      lastName: memberToAdd.lastName,
      type: type,
      membersToNotify: membersToNotify,
      chatId: chatId,
    };
  }
}
